// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"345":"611a7160","576":"611a7160"}[chunkId] + ".chunk.css";
};